import React from "react";

export default function Icon({ icon }) {
  return <span className="text-base text-black flex items-center">{icon}</span>;
}
